<template>
  <div class="supply">
    <navs></navs>
    <div class="supplyBoxOut">
      <p class="bigTitle">运输交易服务</p>
      <p class="smallTitle">TRANSPORT TRANSACTION SERVICE</p>
    </div>
    <h3 class="title">平台优势</h3>
    <div class="supplyCon">
      <img src="../assets/gong.png" />
      <div class="leftTop">
        <div class="num">01</div>
        <div class="nameTitle">资质齐全</div>
        <div class="nameSub">
          资质齐全,加盟携船网以平台名义参与国企及大型企业招投标
        </div>
      </div>
      <div class="rightTop">
        <div class="num">02</div>
        <div class="nameTitle">平台服务</div>
        <div class="nameSub">
          支持电子合同签约,运费7*24小时在线支付,安全快捷
        </div>
      </div>
      <div class="leftBottom">
        <div class="num">03</div>
        <div class="nameTitle">享受平台优惠政策</div>
        <div class="nameSub">平台运输交易可享优惠补贴，帮助降低运输成本</div>
      </div>
      <div class="rightBottom">
        <div class="num">04</div>
        <div class="nameTitle">SaaS订单管理系统</div>
        <div class="nameSub">
          平台优化实际交易流程，将交易全流程嵌入SaaS管理系统，实现信息流、资金流、合同流、发票流、物流等五流合一，应用大数据分析
        </div>
      </div>
    </div>
    <div class="transaction-process">
      <h3 class="title">委托交易流程</h3>
      <div class="sec-bg"></div>
    </div>
    <div class="supply-thd-bg">
      <h3>五流合一 数据交叉验证，真实可靠</h3>
      <p>
        平台通过优化和重塑运输交易全流程，满足业务数据“五流合一”的监管要求，保障业务真实性，得到地方机构的支持和认可
      </p>
      <van-swipe
        :width="150"
        :height="260"
        :loop="false"
        indicator-color="#198CFF"
        class="back-swipe"
      >
        <van-swipe-item>
          <div class="swipe-con">
            <i class="i1"></i><em>信息流</em
            ><span
              >航运大数据实时采集分析数据，精准匹配推送。交易方身份认证、车辆船舶认证</span
            >
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-con">
            <i class="i2"></i><em>合同流</em
            ><span>平台分别与托运人及承运人签署运输合同，支持电子合同签约</span>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-con">
            <i class="i3"></i><em>物流</em
            ><span>在途运输实时监控，历史轨迹随时可溯，运单多方确认签署</span>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-con">
            <i class="i4"></i><em>资金流</em
            ><span>运费资金流向清晰明了，各环节凭证随时调取</span>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="swipe-con">
            <i class="i5"></i><em>发票流</em
            ><span>发票内容与运输合同、运单数据匹配，进销发票一一对应</span>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div style="padding-bottom: 1rem"></div>
    <foot></foot>
    <rightC></rightC>
  </div>
</template>
<script>
import navs from "@/components/nav/head";
import foot from "@/components/nav/footer";
import rightC from "@/components/nav/rightFloat";
export default {
  name: "supply",
  data() {
    return {
      current: 0,
    };
  },
  components: {
    navs,
    foot,
    rightC,
  },
  created() {},
};
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
@col-f: #fff;
.supply {
  .title {
    text-align: center;
  }
}
.transaction-process {
  background-color: #f8f9fa;
  padding: 1rem 1rem 1.5rem;
  margin-top: 1rem;
  .sec-bg {
    width: 100%;
    height: 188 / @rem;
    background: url(../assets/supply-sec-bg.png) no-repeat center center;
    margin: 0 auto;
    background-size: 100% auto;
  }
}
.back-swipe {
  width: 100%;
  height: 300px;
  .van-swipe-item {
    padding: 4px 8px;
    box-sizing: border-box;
    .swipe-con {
      background-color: #fff;
      color: #666;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
      border-radius: 4px;
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      align-items: center;
      padding: 15 / @rem 10 / @rem 10 / @rem;
      box-sizing: border-box;
      i {
        display: block;
        width: 51 / @rem;
        height: 50 / @rem;
      }
      i.i1 {
        background: url(../assets/supply-icon-1.png) no-repeat center center;
        background-size: 100% auto;
      }
      i.i2 {
        background: url(../assets/supply-icon-2.png) no-repeat center center;
        background-size: 100% auto;
      }
      i.i3 {
        background: url(../assets/supply-icon-3.png) no-repeat center center;
        background-size: 100% auto;
      }
      i.i4 {
        background: url(../assets/supply-icon-4.png) no-repeat center center;
        background-size: 100% auto;
      }
      i.i5 {
        background: url(../assets/supply-icon-5.png) no-repeat center center;
        background-size: 100% auto;
      }
      em {
        color: #000;
        font-size: 13 / @rem;
        font-style: normal;
        margin: 10px 0;
      }
      span {
        font-size: 8 / @rem;
        line-height: 15 / @rem;
        text-align: justify;
      }
    }
  }

}
.supply-thd-bg {
  position: relative;
  color: #fff;
  box-sizing: border-box;
  padding: 27 / @rem 0 0 15 / @rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   background-color: #fff;
  h3 {
    font-size: 18 / @rem;
    padding-right: 15 / @rem;
    padding-bottom: 0;
    margin-bottom: 0;
    margin-top: 0;
  }
  p {
    font-size: 10 / @rem;
    text-align: center;
    line-height: 18 / @rem;
    padding-right: 15 / @rem;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.supply-thd-bg::before,
.supply-thd-bg::after {
  content: "";
  display: block;
  width: 100%;
  height: 230 / @rem;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}
.supply-thd-bg::before {
  background: url(../assets/supply-thd-bg.png) no-repeat center 0;
  background-size: 100% auto;
  z-index: -1;
}
.supply-thd-bg::after {
  background: linear-gradient(90deg, #39a2f7 0%, #2585ec 53%, #0e61df 100%);
  z-index: -9;
}
.supplyBoxOut {
  width: 100%;
  height: 160 / @rem;
  background: url("../assets/gong_b_0.png");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ceil(100%) ceil(100%);
  align-items: center;
  p {
    text-align: center;
    color: @col-f;
    font-size: 22 / @rem;
    padding-top: 48 / @rem;
    margin: 0;
    font-weight: 400;
  }
  .smallTitle {
    text-align: center;
    color: @col-f;
    font-size: 10 / @rem;
    padding-top: 10 / @rem;
    font-weight: 300;
  }
}
.supplyCon {
  width: 100%;
  height: 400 / @rem;
  position: relative;
  img {
    width: 300 / @rem;
    height: 220 / @rem;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 8.2rem;
    margin-top: -(110 / @rem)/2;
  }
  .leftTop {
    position: absolute;
    left: 0.8rem;
    top: 0.6rem;
    .num {
      font-size: 22 / @rem;
      color: rgba(25, 140, 255, 0.2);
    }
    .nameTitle {
      font-size: 14 / @rem;
      color: #333;
      font-weight: 500;
    }
    .nameSub {
      font-size: 8 / @rem;
      color: #666;
      width: 128 / @rem;
      text-align: justify;
      margin-top: 6 / @rem;
    }
  }
  .rightTop {
    position: absolute;
    right: 0.3rem;
    top: 0.6rem;
    .num {
      font-size: 22 / @rem;
      color: rgba(25, 140, 255, 0.2);
    }
    .nameTitle {
      font-size: 14 / @rem;
      color: #333;
      font-weight: 500;
    }
    .nameSub {
      font-size: 8 / @rem;
      color: #666;
      width: 102 / @rem;
      text-align: justify;
      margin-top: 6 / @rem;
    }
  }
  .leftBottom {
    position: absolute;
    left: 0.8rem;
    bottom: 1.6rem;
    .num {
      font-size: 22 / @rem;
      color: rgba(25, 140, 255, 0.2);
    }
    .nameTitle {
      font-size: 14 / @rem;
      color: #333;
      font-weight: 500;
    }
    .nameSub {
      font-size: 8 / @rem;
      color: #666;
      width: 128 / @rem;
      text-align: justify;
      margin-top: 6 / @rem;
    }
  }
  .rightBottom {
    position: absolute;
    right: 0.8rem;
    bottom: 0.32rem;
    .num {
      font-size: 22 / @rem;
      color: rgba(25, 140, 255, 0.2);
    }
    .nameTitle {
      font-size: 14 / @rem;
      color: #333;
      font-weight: 500;
    }
    .nameSub {
      font-size: 8 / @rem;
      color: #666;
      width: 128 / @rem;
      text-align: justify;
      margin-top: 6 / @rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supply.vue